/**
 * Created by mh on 2017/5/23.
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import { observer, inject } from 'mobx-react';

import Spinner from '../Spinner';

import AssetVisualPreview from './AssetVisualPreview';

import { MdMusicNote, MdImage, MdVideoLibrary, MdReportProblem } from 'react-icons/md';

// TODO generalize
const TypeToIcon = (type) => {
    switch (type) {
    case 'video':
        // TODO change to single video
        return <MdVideoLibrary />;
    case 'audio':
        return <MdMusicNote />;
    case 'still':
        return <MdImage />;
    default:
        return <MdReportProblem />;
    }
};

const externalRefs = refs => (
    refs.map(r => r.dmrn).join('<br /> ')
);

@inject('assets') @observer
class AssetAudioPlayer extends Component {
    componentDidMount = () => {
        // Data will be loaded by parent asset details component
    };

    render() {
        const { asset } = this.props.assets;
        if (!asset || !asset.id) {
            return <Spinner />;
        }
        return (
            <section>
                <div className="row">
                    <div className="col-12">
                        <AssetVisualPreview asset={asset} audioPlayer />
                    </div>
                </div>
            </section>
        );
    }
}

AssetAudioPlayer.wrappedComponent.propTypes = {
    // auth: PropTypes.object.isRequired,
    // match: PropTypes.object.isRequired,
};

export default injectIntl(AssetAudioPlayer);
